// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/next-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/next-arrow-hover.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

[type='checkbox'],[type='radio']{
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox']{
  border-radius: 0px;
}

[type='radio']{
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  [type='checkbox']:checked{
    appearance: auto;
  }
}

[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  [type='radio']:checked{
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  [type='checkbox']:indeterminate{
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='file']{
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  max-width: 1920px;
  padding-left: 5rem;
  padding-right: 5rem;
}
@media (max-width: 1800px){

  .container{
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (max-width: 991px){

  .container{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media (max-width: 767px){

  .container{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
}
/* COMMON SPACING */
.section-space{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
@media (max-width: 1600px){

  .section-space{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
}
@media (max-width: 1399px){

  .section-space{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
}
@media (max-width: 991px){

  .section-space{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}
@media (max-width: 767px){

  .section-space{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}
.section-space-small{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
@media (max-width: 1600px){

  .section-space-small{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
}
@media (max-width: 1399px){

  .section-space-small{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
}
@media (max-width: 991px){

  .section-space-small{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}
@media (max-width: 767px){

  .section-space-small{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}
/* BUTTON CSS */
.btn-primary{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-duration: 300ms;
}
.btn-primary::after{
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -10;
  height: 100%;
  width: 200%;
  background-image: linear-gradient(84.95deg, #54D2FF 3.35%, #BEA4FF 14.99%, #EF95E9 27.67%, #F9B86A 37.15%, #FCC340 45.67%, #FDC82C 56.82%, #F9B86A 67.66%, #EF95E9 78.44%, #BEA4FF 87.04%, #54D2FF 97.47%);
  content: var(--tw-content);
  transition-duration: 300ms;
}
.btn-primary:hover::after{
  content: var(--tw-content);
  left: -100%;
}
@media (max-width: 1199px){

  .btn-primary{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (max-width: 767px){

  .btn-primary{
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
}
.btn-secondary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-duration: 300ms;
}
.btn-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
@media (max-width: 1199px){

  .btn-secondary{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (max-width: 767px){

  .btn-secondary{
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
}
.btn-border{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
  transition-duration: 300ms;
}
.btn-border:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (max-width: 1199px){

  .btn-border{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (max-width: 767px){

  .btn-border{
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
}
.btn-sm{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.125rem;
}
@media (max-width: 1199px){

  .btn-sm{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
@media (max-width: 767px){

  .btn-sm{
    border-radius: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
}
.btn-sm img{
  width: 1.25rem;
}
/* BUTTON CSS END */
/* MAIN HEADING CSS */
.main-heading-h1{
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
  -webkit-background-clip: text;
          background-clip: text;
  font-family: Montserrat, serif;
  font-size: 6.125rem;
  line-height: 1;
  font-weight: 900;
  color: transparent;
}
@media (max-width: 1800px){

  .main-heading-h1{
    font-size: 5rem;
    line-height: 5.625rem;
  }
}
@media (max-width: 1399px){

  .main-heading-h1{
    font-size: 4rem;
    line-height: 5.5rem;
    line-height: 1;
  }
}
@media (max-width: 1199px){

  .main-heading-h1{
    font-size: 3.625rem;
    line-height: 3.75rem;
  }
}
@media (max-width: 767px){

  .main-heading-h1{
    font-size: 2.5rem;
    line-height: 3rem;
  }
}
.main-heading-h2{
  display: inline-block;
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
  -webkit-background-clip: text;
          background-clip: text;
  font-family: Montserrat, serif;
  font-size: 5rem;
  line-height: 5.625rem;
  font-weight: 900;
  color: transparent;
}
@media (max-width: 1600px){

  .main-heading-h2{
    font-size: 4rem;
    line-height: 5.5rem;
  }
}
@media (max-width: 1199px){

  .main-heading-h2{
    font-size: 3.625rem;
    line-height: 3.75rem;
  }
}
@media (max-width: 767px){

  .main-heading-h2{
    font-size: 2.5rem;
    line-height: 3rem;
  }
}
/* MAIN HEADING CSS END */
.dropdown{
  position: absolute;
  overflow: hidden;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 25px 50px 0 rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 25px 50px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dropdown:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
/* TABLE TH */
.table-main{
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  font-size: 1.125rem;
  line-height: 1.625rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
@media (max-width: 991px){

  .table-main{
    font-size: 1rem;
    line-height: 1.375rem;
  }
}
.table-th{
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(195 195 195 / var(--tw-border-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.75rem;
  text-align: left;
}
.table-th:first-child{
  padding-left: 0px;
}
.table-th:last-child{
  padding-right: 0px;
}
.table-th span{
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
  -webkit-background-clip: text;
          background-clip: text;
  font-size: 1.375rem;
  line-height: 1.75rem;
  font-weight: 700;
  color: transparent;
}
@media (max-width: 991px){

  .table-th span{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (max-width: 767px){

  .table-th span{
    font-size: 1.125rem;
    line-height: 1.625rem;
  }
}
.table-td{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.table-td:first-child{
  padding-left: 0px;
}
.table-td:last-child{
  padding-right: 0px;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-3{
  right: -0.75rem;
}
.-top-16{
  top: -4rem;
}
.-top-3{
  top: -0.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-11{
  bottom: 2.75rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-8{
  bottom: 2rem;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2\\/3{
  left: 66.666667%;
}
.left-2\\/4{
  left: 50%;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-6{
  left: 1.5rem;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-11{
  right: 2.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-7{
  right: 1.75rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-7{
  top: 1.75rem;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[3\\]{
  z-index: 3;
}
.z-\\[5\\]{
  z-index: 5;
}
.float-right{
  float: right;
}
.-m-1{
  margin: -0.25rem;
}
.-m-1\\.5{
  margin: -0.375rem;
}
.-m-2{
  margin: -0.5rem;
}
.-m-2\\.5{
  margin: -0.625rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-2\\.5{
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-my-1{
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-my-20{
  margin-top: -5rem;
  margin-bottom: -5rem;
}
.-my-6{
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-ml-8{
  margin-left: -2rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-10{
  margin-right: -2.5rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mt-0{
  margin-top: -0px;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.-mt-10{
  margin-top: -2.5rem;
}
.-mt-5{
  margin-top: -1.25rem;
}
.-mt-7{
  margin-top: -1.75rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-32{
  margin-bottom: 8rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0{
  margin-right: 0px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-2\\.5{
  margin-right: 0.625rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-11{
  margin-top: 2.75rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-36{
  margin-top: 9rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-40{
  margin-top: 10rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-5{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.flow-root{
  display: flow-root;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[20rem\\]{
  height: 20rem;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[430px\\]{
  height: 430px;
}
.h-\\[567px\\]{
  height: 567px;
}
.h-\\[8rem\\]{
  height: 8rem;
}
.h-full{
  height: 100%;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-\\[34rem\\]{
  max-height: 34rem;
}
.max-h-\\[calc\\(100vh-100px\\)\\]{
  max-height: calc(100vh - 100px);
}
.min-h-\\[450px\\]{
  min-height: 450px;
}
.min-h-full{
  min-height: 100%;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/12{
  width: 8.333333%;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-1\\/5{
  width: 20%;
}
.w-1\\/6{
  width: 16.666667%;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/5{
  width: 40%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\/5{
  width: 60%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/12{
  width: 41.666667%;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-8\\/12{
  width: 66.666667%;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[13\\%\\]{
  width: 13%;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[17\\%\\]{
  width: 17%;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[34px\\]{
  width: 34px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[calc\\(100\\%\\/3-11px\\)\\]{
  width: calc(100% / 3 - 11px);
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[138px\\]{
  min-width: 138px;
}
.min-w-\\[28px\\]{
  min-width: 28px;
}
.min-w-\\[380px\\]{
  min-width: 380px;
}
.min-w-\\[420px\\]{
  min-width: 420px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1410px\\]{
  max-width: 1410px;
}
.max-w-\\[1528px\\]{
  max-width: 1528px;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[30\\%\\]{
  flex: 30% 1;
}
.flex-\\[70\\%\\]{
  flex: 70% 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[200\\%\\]{
  --tw-translate-x: -200%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full{
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/3{
  --tw-translate-y: 33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2{
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4{
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.99\\]{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin-slow{
  animation: spin 30s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.resize-none{
  resize: none;
}
.\\!grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.\\!grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-rows-3{
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-14{
  gap: 3.5rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-20{
  gap: 5rem;
}
.gap-24{
  gap: 6rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-32{
  gap: 8rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-9{
  gap: 2.25rem;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-y-10{
  row-gap: 2.5rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-2\\.5{
  row-gap: 0.625rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-5{
  row-gap: 1.25rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.\\!border-black{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.\\!border-dark-30{
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity)) !important;
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-black\\/10{
  border-color: rgb(0 0 0 / 0.1);
}
.border-dark-10{
  --tw-border-opacity: 1;
  border-color: rgb(246 246 246 / var(--tw-border-opacity));
}
.border-dark-20{
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.border-dark-30{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}
.border-dark-40{
  --tw-border-opacity: 1;
  border-color: rgb(195 195 195 / var(--tw-border-opacity));
}
.border-dark-80{
  --tw-border-opacity: 1;
  border-color: rgb(102 102 102 / var(--tw-border-opacity));
}
.border-purple{
  --tw-border-opacity: 1;
  border-color: rgb(185 169 251 / var(--tw-border-opacity));
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!border-b-dark-60{
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(128 128 128 / var(--tw-border-opacity)) !important;
}
.border-b-dark-20{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.\\!bg-black{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#E6FBFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(230 251 255 / var(--tw-bg-opacity));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/25{
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/\\[0\\.5\\]{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-dark-10{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity));
}
.bg-dark-10\\/40{
  background-color: rgb(246 246 246 / 0.4);
}
.bg-dark-30{
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}
.bg-dark-90{
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity));
}
.bg-darkGray{
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 37 / var(--tw-bg-opacity));
}
.bg-error{
  --tw-bg-opacity: 1;
  background-color: rgb(255 97 97 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(56 222 255 / var(--tw-bg-opacity));
}
.bg-primary\\/10{
  background-color: rgb(56 222 255 / 0.1);
}
.bg-primary\\/20{
  background-color: rgb(56 222 255 / 0.2);
}
.bg-purple{
  --tw-bg-opacity: 1;
  background-color: rgb(185 169 251 / var(--tw-bg-opacity));
}
.bg-secondary\\/20{
  background-color: rgb(238 143 255 / 0.2);
}
.bg-tertiary\\/20{
  background-color: rgb(255 217 68 / 0.2);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-\\[image\\:var\\(--image-url\\)\\]{
  background-image: var(--image-url);
}
.bg-bg_gradient{
  background-image: linear-gradient(85deg, rgba(0, 0, 0, 0.38)0%, rgba(0, 0, 0, 0.33)99.27%);
}
.bg-gradient{
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
}
.bg-\\[length\\:100\\%_100\\%\\]{
  background-size: 100% 100%;
}
.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-28{
  padding-left: 7rem;
  padding-right: 7rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-16{
  padding-right: 4rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-3\\.5{
  padding-right: 0.875rem;
}
.pr-32{
  padding-right: 8rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-40{
  padding-top: 10rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-\\[100\\%\\]{
  padding-top: 100%;
}
.pt-\\[23\\.3\\%\\]{
  padding-top: 23.3%;
}
.pt-\\[30\\.5\\%\\]{
  padding-top: 30.5%;
}
.pt-\\[50\\%\\]{
  padding-top: 50%;
}
.pt-\\[70\\%\\]{
  padding-top: 70%;
}
.pt-\\[74\\%\\]{
  padding-top: 74%;
}
.pt-\\[86\\%\\]{
  padding-top: 86%;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-darker{
  font-family: Darker Grotesque, sans-serif;
}
.font-inter{
  font-family: Inter, serif;
}
.font-monserrat{
  font-family: Montserrat, serif;
}
.text-2xl{
  font-size: 1.875rem;
  line-height: 2.375rem;
}
.text-3xl{
  font-size: 3.625rem;
  line-height: 3.75rem;
}
.text-4xl{
  font-size: 4rem;
  line-height: 5.5rem;
}
.text-5xl{
  font-size: 5rem;
  line-height: 5.625rem;
}
.text-6xl{
  font-size: 6.125rem;
  line-height: 1;
}
.text-\\[48px\\]{
  font-size: 48px;
}
.text-base{
  font-size: 1.125rem;
  line-height: 1.625rem;
}
.text-lg{
  font-size: 1.375rem;
  line-height: 1.75rem;
}
.text-md{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 1rem;
  line-height: 1.375rem;
}
.text-xl{
  font-size: 1.5rem;
  line-height: 1.875rem;
}
.text-xs{
  font-size: 0.875rem;
  line-height: 1.125rem;
}
.text-xxs{
  font-size: 0.625rem;
  line-height: 0.875rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-none{
  line-height: 1;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#2D1B30\\]{
  --tw-text-opacity: 1;
  color: rgb(45 27 48 / var(--tw-text-opacity));
}
.text-\\[\\#362F10\\]{
  --tw-text-opacity: 1;
  color: rgb(54 47 16 / var(--tw-text-opacity));
}
.text-\\[\\#6D643D\\]{
  --tw-text-opacity: 1;
  color: rgb(109 100 61 / var(--tw-text-opacity));
}
.text-\\[\\#78A1B8\\]{
  --tw-text-opacity: 1;
  color: rgb(120 161 184 / var(--tw-text-opacity));
}
.text-\\[\\#966D9D\\]{
  --tw-text-opacity: 1;
  color: rgb(150 109 157 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-cyan-950{
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity));
}
.text-dark-30{
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}
.text-dark-50{
  --tw-text-opacity: 1;
  color: rgb(179 179 179 / var(--tw-text-opacity));
}
.text-dark-60{
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-dark-70{
  --tw-text-opacity: 1;
  color: rgb(118 118 118 / var(--tw-text-opacity));
}
.text-dark-80{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.text-dark-90{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-darkGray{
  --tw-text-opacity: 1;
  color: rgb(32 32 37 / var(--tw-text-opacity));
}
.text-darkgreen{
  --tw-text-opacity: 1;
  color: rgb(0 63 75 / var(--tw-text-opacity));
}
.text-gray{
  --tw-text-opacity: 1;
  color: rgb(119 126 144 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(56 222 255 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-secondary{
  --tw-text-opacity: 1;
  color: rgb(238 143 255 / var(--tw-text-opacity));
}
.text-tertiary{
  --tw-text-opacity: 1;
  color: rgb(255 217 68 / var(--tw-text-opacity));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-50{
  opacity: 0.5;
}
.shadow-\\[25px_25px_50px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\]{
  --tw-shadow: 25px 25px 50px 0px rgba(0,0,0,0.15);
  --tw-shadow-colored: 25px 25px 50px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0px_0px_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\]{
  --tw-shadow: inset 0 0px 0px 2px rgba(255,255,255,1);
  --tw-shadow-colored: inset 0 0px 0px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/50{
  --tw-shadow-color: rgb(0 0 0 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-150{
  transition-delay: 150ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* SLIDER ARROW */

.slick-track {
  margin-left: 0;
  display: flex;
}
.slick-slide {
  min-height: 100%;
  height: auto;
}
.slick-slide > div {
  height: 100%;
}
.slick-prev,
.slick-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  right: -3.5rem;
  margin-right: -0.5rem;
  height: auto;
  width: auto;
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  padding: 1.75rem;
  transition-duration: 300ms;
}
.slick-prev::before,
.slick-next::before{
  content: var(--tw-content);
  display: none;
}
.slick-prev:hover,
.slick-next:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
@media (max-width: 1800px){

  .slick-prev,
.slick-next{
    margin-right: 0px;
  }
}
@media (max-width: 1199px){

  .slick-prev,
.slick-next{
    padding: 1.5rem;
  }
}
@media (max-width: 991px){

  .slick-prev,
.slick-next{
    right: -2.5rem;
    padding: 1.25rem;
  }
}
@media (max-width: 767px){

  .slick-prev,
.slick-next{
    right: -2rem;
    background-size: 60% 60%;
    padding: 1rem;
  }
}
.slick-prev:hover,
.slick-next:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-position: center;
  background-repeat: no-repeat;
}
.slick-prev{
  right: auto;
  left: -3.5rem;
  margin-left: -0.5rem;
  --tw-translate-y: -50%;
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (max-width: 1800px){

  .slick-prev{
    margin-left: 0px;
  }
}
@media (max-width: 991px){

  .slick-prev{
    left: -2.5rem;
  }
}
@media (max-width: 767px){

  .slick-prev{
    left: -2rem;
  }
}

/* DATEPICKER CSS start*/
.react-datepicker{
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  font-size: 1rem !important;
  line-height: 1.375rem !important;
}
.react-datepicker-wrapper{
  width: 100%;
}
.react-datepicker__portal{
  height: 100% !important;
  width: 100% !important;
}
.react-datepicker__tab-loop{
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 30;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgb(32 32 37 / 0.8);
}
.react-datepicker-popper{
  position: relative !important;
  transform: none !important;
}
.react-datepicker__children-container{
  clear: both;
  margin: 0px !important;
  display: flex;
  width: 100% !important;
  justify-content: center;
  gap: 0.75rem;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(195 195 195 / var(--tw-border-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name{
  height: 2rem !important;
  width: 2rem !important;
  line-height: 2rem !important;
}
.react-datepicker__triangle{
  display: none !important;
}
/* LOADER CSS start*/

.configure-border-1 {
  width: 112px;
  height: 112px;
  padding: 3px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 3px #0d0b0e;
  animation: configure-clockwise 3s ease-in-out 0s infinite alternate;
}

.configure-border-2 {
  width: 115px;
  height: 115px;
  padding: 3px;
  left: -115px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(63, 249, 220);
  transform: rotate(45deg);
  background-image: radial-gradient(
    135% 135% at 99.89% 100.17%,
    #ffcf14 0%,
    #ee8fff 52%,
    #38deff 100%
  );
  animation: configure-xclockwise 3s ease-in-out 0s infinite alternate;
}

/* .configure-core {
    width: 100%;
    height: 100%;
    background-color: #1d2630;
} */

@keyframes configure-clockwise {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes configure-xclockwise {
  0% {
    transform: rotate(45deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-135deg);
  }
  75% {
    transform: rotate(-225deg);
  }
  100% {
    transform: rotate(-315deg);
  }
}
.loader-btn {
  width: 28px;
  height: 28px;
  border: 5px dotted #38deff;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  margin: -5px 10px -5px 0;
  animation: rotation 2s linear infinite;
}
/* keyFrames */
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* VideoPlayer.css */
.custom-video::-webkit-media-controls-fullscreen-button,
.custom-video::-webkit-media-controls-overflow-button {
  display: none !important;
}

/* to hide react-quill input box */
.bubble > .ql-container > .ql-clipboard {
  display: none !important;
}

.bubble > .ql-container > .ql-tooltip {
  display: none !important;
}
.bubble > .ql-container > .ql-tooltip > .ql-tooltip-editor > input a {
  display: none !important;
}

/* react-quill */

.font-change-css h1 {
  font-size: 2.25rem;
  font-weight: 700;
  padding: 8px 0px;
}

.font-change-css h2 {
  font-size: 1.875rem;
  font-weight: 700;
  padding: 8px 0px;
}

.font-change-css h3 {
  font-size: 1.5rem;
  font-weight: 700;
  padding: 8px 0px;
}

.font-change-css h4 {
  font-size: 1.25rem;
  font-weight: 600;
  padding: 8px 0px;
}

.font-change-css h5 {
  font-size: 1.125rem;
  font-weight: 600;
  padding: 8px 0px;
}

.font-change-css h6 {
  font-size: 0.875rem;
  font-weight: 600;
  padding: 8px 0px;
}

.font-change-css p {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

.font-change-css ul {
  list-style-type: disc;
  padding-left: 1.5rem;
}
.font-change-css ul > li {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.font-change-css ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
}
.font-change-css ol > li {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

.font-change-css p img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 0) and (max-width: 767px) {
  .font-change-css h1 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  .font-change-css h2 {
    font-size: 1.2rem;
    font-weight: 700;
  }

  .font-change-css h3 {
    font-size: 1rem;
    font-weight: 700;
  }

  .font-change-css h4 {
    font-size: 0.925rem;
    font-weight: 600;
  }

  .font-change-css h5 {
    font-size: 0.8rem;
    font-weight: 600;
  }

  .font-change-css h6 {
    font-size: 0.8rem;
    font-weight: 600;
  }
  .font-change-css ul {
    list-style-type: disc;
    padding-left: 1.5rem;
  }
  .font-change-css ul > li {
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
  .font-change-css ol {
    list-style-type: decimal;
    padding-left: 1.5rem;
  }
  .font-change-css ol > li {
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
}

@media (max-width: 575px){

  @media (max-width: 767px){
  .xs\\:sm\\:btn-sm{
      padding-top: 0.375rem;
      padding-bottom: 0.375rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      font-size: 0.875rem;
      line-height: 1.125rem;
    }
  @media (max-width: 1199px){

      .xs\\:sm\\:btn-sm{
        padding-left: 1.25rem;
        padding-right: 1.25rem;
      }
    }
  @media (max-width: 767px){

      .xs\\:sm\\:btn-sm{
        border-radius: 0.5rem;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
      }
    }
  .xs\\:sm\\:btn-sm img{
      width: 1.25rem;
    }
  }
}

.placeholder\\:text-dark-60::placeholder{
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}

.placeholder\\:text-dark-80::placeholder{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-0::before{
  content: var(--tw-content);
  left: 0px;
}

.before\\:left-3\\/4::before{
  content: var(--tw-content);
  left: 75%;
}

.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}

.before\\:top-11::before{
  content: var(--tw-content);
  top: 2.75rem;
}

.before\\:z-\\[2\\]::before{
  content: var(--tw-content);
  z-index: 2;
}

.before\\:h-\\[3px\\]::before{
  content: var(--tw-content);
  height: 3px;
}

.before\\:h-full::before{
  content: var(--tw-content);
  height: 100%;
}

.before\\:w-3\\/5::before{
  content: var(--tw-content);
  width: 60%;
}

.before\\:w-full::before{
  content: var(--tw-content);
  width: 100%;
}

.before\\:rounded-xl::before{
  content: var(--tw-content);
  border-radius: 0.75rem;
}

.before\\:border-\\[5px\\]::before{
  content: var(--tw-content);
  border-width: 5px;
}

.before\\:bg-gradient::before{
  content: var(--tw-content);
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:-bottom-1::after{
  content: var(--tw-content);
  bottom: -0.25rem;
}

.after\\:-bottom-2::after{
  content: var(--tw-content);
  bottom: -0.5rem;
}

.after\\:left-0::after{
  content: var(--tw-content);
  left: 0px;
}

.after\\:top-0::after{
  content: var(--tw-content);
  top: 0px;
}

.after\\:h-\\[3px\\]::after{
  content: var(--tw-content);
  height: 3px;
}

.after\\:h-full::after{
  content: var(--tw-content);
  height: 100%;
}

.after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}

.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:bg-gradient::after{
  content: var(--tw-content);
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
}

.after\\:opacity-0::after{
  content: var(--tw-content);
  opacity: 0;
}

.after\\:opacity-100::after{
  content: var(--tw-content);
  opacity: 1;
}

.after\\:duration-300::after{
  content: var(--tw-content);
  transition-duration: 300ms;
}

.after\\:duration-700::after{
  content: var(--tw-content);
  transition-duration: 700ms;
}

.first\\:col-span-2:first-child{
  grid-column: span 2 / span 2;
}

.first\\:row-span-3:first-child{
  grid-row: span 3 / span 3;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.first\\:last\\:col-span-3:last-child:first-child{
  grid-column: span 3 / span 3;
}

.hover\\:z-\\[5\\]:hover{
  z-index: 5;
}

.hover\\:-translate-y-2:hover{
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-2\\.5:hover{
  --tw-translate-y: -0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-100:hover{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-black:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.hover\\:border-dark-20:hover{
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}

.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.hover\\:bg-dark-10:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity));
}

.hover\\:bg-primary\\/20:hover{
  background-color: rgb(56 222 255 / 0.2);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.hover\\:text-dark-80:hover{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}

.hover\\:text-dark-90:hover{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}

.hover\\:text-primary:hover{
  --tw-text-opacity: 1;
  color: rgb(56 222 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:after\\:opacity-100:hover::after{
  content: var(--tw-content);
  opacity: 1;
}

.focus\\:\\!border-dark-70:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(118 118 118 / var(--tw-border-opacity)) !important;
}

.focus\\:border-dark-70:focus{
  --tw-border-opacity: 1;
  border-color: rgb(118 118 118 / var(--tw-border-opacity));
}

.focus\\:\\!shadow-none:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:\\!shadow-transparent:focus{
  --tw-shadow-color: transparent !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-transparent:focus{
  --tw-ring-color: transparent;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.active\\:border-dark-70:active{
  --tw-border-opacity: 1;
  border-color: rgb(118 118 118 / var(--tw-border-opacity));
}

.group:hover .group-hover\\:visible{
  visibility: visible;
}

.group:hover .group-hover\\:-top-2{
  top: -0.5rem;
}

.group:hover .group-hover\\:-top-2\\.5{
  top: -0.625rem;
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:translate-y-2{
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-dark-30{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}

.group:hover .group-hover\\:bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-darkGray{
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 37 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-gradient{
  background-image: linear-gradient(85.42deg, #54D2FF 4.37%, #BEA4FF 29.97%, #EF95E9 53.54%, #F9B86A 76.49%, #FCC340 91.67%, #FDC82C 99.07%);
}

.group:hover .group-hover\\:bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}

.group:hover .group-hover\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-dark-40{
  --tw-text-opacity: 1;
  color: rgb(195 195 195 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-dark-80{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-transparent{
  color: transparent;
}

.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group:hover .group-hover\\:invert-0{
  --tw-invert: invert(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group:hover .group-hover\\:before\\:border-white::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:relative{
  position: relative;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:top-0{
  top: 0px;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:block{
  display: block;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:inline-block{
  display: inline-block;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:h-0{
  height: 0px;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:h-auto{
  height: auto;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:w-full{
  width: 100%;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:flex-col{
  flex-direction: column;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:gap-3{
  gap: 0.75rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:rounded-md{
  border-radius: 0.375rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:rounded-none{
  border-radius: 0px;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:bg-dark-10{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity));
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:bg-transparent{
  background-color: transparent;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:pb-4{
  padding-bottom: 1rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:text-sm{
  font-size: 1rem;
  line-height: 1.375rem;
}

.group.mobile-active .group-\\[\\.mobile-active\\]\\:shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.btn-border:hover .group-\\[\\.btn-border\\:hover\\]\\:invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group.edit-icon:hover .group-\\[\\.edit-icon\\:hover\\]\\:invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.aria-\\[expanded\\=true\\]\\:border-dark-70[aria-expanded=true]{
  --tw-border-opacity: 1;
  border-color: rgb(118 118 118 / var(--tw-border-opacity));
}

@media (max-width: 1920px){

  .\\34xl\\:h-\\[34rem\\]{
    height: 34rem;
  }
}

@media (max-width: 1800px){

  .\\33xl\\:h-\\[30rem\\]{
    height: 30rem;
  }

  .\\33xl\\:gap-14{
    gap: 3.5rem;
  }

  .\\33xl\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:pr-0{
    padding-right: 0px;
  }

  .\\33xl\\:text-2\\.5xl{
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .\\33xl\\:text-3xl{
    font-size: 3.625rem;
    line-height: 3.75rem;
  }

  .\\33xl\\:text-sm{
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .\\33xl\\:text-xl{
    font-size: 1.5rem;
    line-height: 1.875rem;
  }
}

@media (max-width: 1600px){

  .\\32xl\\:ml-3{
    margin-left: 0.75rem;
  }

  .\\32xl\\:mr-3{
    margin-right: 0.75rem;
  }

  .\\32xl\\:h-\\[26rem\\]{
    height: 26rem;
  }

  .\\32xl\\:w-24{
    width: 6rem;
  }

  .\\32xl\\:w-7{
    width: 1.75rem;
  }

  .\\32xl\\:w-96{
    width: 24rem;
  }

  .\\32xl\\:w-\\[calc\\(100\\%\\/2-8px\\)\\]{
    width: calc(100% / 2 - 8px);
  }

  .\\32xl\\:-translate-x-\\[120\\%\\]{
    --tw-translate-x: -120%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\32xl\\:gap-20{
    gap: 5rem;
  }

  .\\32xl\\:gap-5{
    gap: 1.25rem;
  }

  .\\32xl\\:gap-6{
    gap: 1.5rem;
  }

  .\\32xl\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\32xl\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:pl-6{
    padding-left: 1.5rem;
  }

  .\\32xl\\:pr-0{
    padding-right: 0px;
  }

  .\\32xl\\:pt-12{
    padding-top: 3rem;
  }

  .\\32xl\\:pt-16{
    padding-top: 4rem;
  }

  .\\32xl\\:pt-20{
    padding-top: 5rem;
  }

  .\\32xl\\:text-2\\.5xl{
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .\\32xl\\:text-3xl{
    font-size: 3.625rem;
    line-height: 3.75rem;
  }

  .\\32xl\\:text-lg{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  .\\32xl\\:text-md{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .\\32xl\\:text-sm{
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .\\32xl\\:text-xl{
    font-size: 1.5rem;
    line-height: 1.875rem;
  }
}

@media (max-width: 1399px){

  .xl\\:bottom-6{
    bottom: 1.5rem;
  }

  .xl\\:right-6{
    right: 1.5rem;
  }

  .xl\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .xl\\:hidden{
    display: none;
  }

  .xl\\:h-10{
    height: 2.5rem;
  }

  .xl\\:h-12{
    height: 3rem;
  }

  .xl\\:w-10{
    width: 2.5rem;
  }

  .xl\\:w-12{
    width: 3rem;
  }

  .xl\\:w-2\\/3{
    width: 66.666667%;
  }

  .xl\\:w-20{
    width: 5rem;
  }

  .xl\\:w-80{
    width: 20rem;
  }

  .xl\\:w-full{
    width: 100%;
  }

  .xl\\:max-w-\\[170px\\]{
    max-width: 170px;
  }

  .xl\\:max-w-\\[280px\\]{
    max-width: 280px;
  }

  .xl\\:max-w-sm{
    max-width: 24rem;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:flex-col{
    flex-direction: column;
  }

  .xl\\:flex-wrap{
    flex-wrap: wrap;
  }

  .xl\\:items-start{
    align-items: flex-start;
  }

  .xl\\:gap-10{
    gap: 2.5rem;
  }

  .xl\\:gap-12{
    gap: 3rem;
  }

  .xl\\:gap-16{
    gap: 4rem;
  }

  .xl\\:gap-3{
    gap: 0.75rem;
  }

  .xl\\:gap-3\\.5{
    gap: 0.875rem;
  }

  .xl\\:gap-4{
    gap: 1rem;
  }

  .xl\\:gap-6{
    gap: 1.5rem;
  }

  .xl\\:gap-x-5{
    column-gap: 1.25rem;
  }

  .xl\\:gap-x-8{
    column-gap: 2rem;
  }

  .xl\\:p-4{
    padding: 1rem;
  }

  .xl\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:pl-5{
    padding-left: 1.25rem;
  }

  .xl\\:pt-16{
    padding-top: 4rem;
  }

  .xl\\:pt-2{
    padding-top: 0.5rem;
  }

  .xl\\:pt-36{
    padding-top: 9rem;
  }

  .xl\\:text-left{
    text-align: left;
  }

  .xl\\:text-2\\.5xl{
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .xl\\:text-2xl{
    font-size: 1.875rem;
    line-height: 2.375rem;
  }

  .xl\\:text-\\[32px\\]{
    font-size: 32px;
  }

  .xl\\:text-base{
    font-size: 1.125rem;
    line-height: 1.625rem;
  }

  .xl\\:text-lg{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  .xl\\:text-xl{
    font-size: 1.5rem;
    line-height: 1.875rem;
  }
}

@media (max-width: 1199px){

  .lg\\:top-5{
    top: 1.25rem;
  }

  .lg\\:mb-12{
    margin-bottom: 3rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-12{
    height: 3rem;
  }

  .lg\\:h-16{
    height: 4rem;
  }

  .lg\\:h-6{
    height: 1.5rem;
  }

  .lg\\:w-12{
    width: 3rem;
  }

  .lg\\:w-16{
    width: 4rem;
  }

  .lg\\:w-2\\/3{
    width: 66.666667%;
  }

  .lg\\:w-2\\/5{
    width: 40%;
  }

  .lg\\:w-20{
    width: 5rem;
  }

  .lg\\:w-48{
    width: 12rem;
  }

  .lg\\:w-5{
    width: 1.25rem;
  }

  .lg\\:w-6{
    width: 1.5rem;
  }

  .lg\\:w-60{
    width: 15rem;
  }

  .lg\\:w-72{
    width: 18rem;
  }

  .lg\\:w-9\\/12{
    width: 75%;
  }

  .lg\\:w-full{
    width: 100%;
  }

  .lg\\:max-w-none{
    max-width: none;
  }

  .lg\\:\\!grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:gap-0{
    gap: 0px;
  }

  .lg\\:gap-16{
    gap: 4rem;
  }

  .lg\\:gap-5{
    gap: 1.25rem;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:gap-x-5{
    column-gap: 1.25rem;
  }

  .lg\\:border-b{
    border-bottom-width: 1px;
  }

  .lg\\:border-dark-30{
    --tw-border-opacity: 1;
    border-color: rgb(217 217 217 / var(--tw-border-opacity));
  }

  .lg\\:p-0{
    padding: 0px;
  }

  .lg\\:p-1{
    padding: 0.25rem;
  }

  .lg\\:p-1\\.5{
    padding: 0.375rem;
  }

  .lg\\:p-2{
    padding: 0.5rem;
  }

  .lg\\:p-2\\.5{
    padding: 0.625rem;
  }

  .lg\\:p-4{
    padding: 1rem;
  }

  .lg\\:p-5{
    padding: 1.25rem;
  }

  .lg\\:\\!py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .lg\\:\\!py-3\\.5{
    padding-top: 0.875rem !important;
    padding-bottom: 0.875rem !important;
  }

  .lg\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .lg\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pb-16{
    padding-bottom: 4rem;
  }

  .lg\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .lg\\:pr-9{
    padding-right: 2.25rem;
  }

  .lg\\:pt-12{
    padding-top: 3rem;
  }

  .lg\\:pt-14{
    padding-top: 3.5rem;
  }

  .lg\\:pt-24{
    padding-top: 6rem;
  }

  .lg\\:text-2\\.5xl{
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .lg\\:text-base{
    font-size: 1.125rem;
    line-height: 1.625rem;
  }

  .lg\\:text-md{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm{
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .lg\\:text-xl{
    font-size: 1.5rem;
    line-height: 1.875rem;
  }

  .lg\\:before\\:left-\\[80\\%\\]::before{
    content: var(--tw-content);
    left: 80%;
  }

  .lg\\:before\\:w-1\\/2::before{
    content: var(--tw-content);
    width: 50%;
  }

  .lg\\:last\\:border-b-0:last-child{
    border-bottom-width: 0px;
  }

  @media (max-width: 1399px){

    .lg\\:xl\\:h-\\[22rem\\]{
      height: 22rem;
    }
  }
}

@media (max-width: 991px){

  .md\\:fixed{
    position: fixed;
  }

  .md\\:relative{
    position: relative;
  }

  .md\\:left-0{
    left: 0px;
  }

  .md\\:right-7{
    right: 1.75rem;
  }

  .md\\:top-0{
    top: 0px;
  }

  .md\\:top-3{
    top: 0.75rem;
  }

  .md\\:top-\\[85px\\]{
    top: 85px;
  }

  .md\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .md\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .md\\:-mt-2{
    margin-top: -0.5rem;
  }

  .md\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .md\\:ml-2{
    margin-left: 0.5rem;
  }

  .md\\:mr-0{
    margin-right: 0px;
  }

  .md\\:mr-4{
    margin-right: 1rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-10{
    margin-top: 2.5rem;
  }

  .md\\:mt-12{
    margin-top: 3rem;
  }

  .md\\:mt-5{
    margin-top: 1.25rem;
  }

  .md\\:mt-7{
    margin-top: 1.75rem;
  }

  .md\\:mt-9{
    margin-top: 2.25rem;
  }

  .md\\:\\!block{
    display: block !important;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-72{
    height: 18rem;
  }

  .md\\:h-9{
    height: 2.25rem;
  }

  .md\\:h-\\[450px\\]{
    height: 450px;
  }

  .md\\:min-h-\\[150px\\]{
    min-height: 150px;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-14{
    width: 3.5rem;
  }

  .md\\:w-2\\/5{
    width: 40%;
  }

  .md\\:w-20{
    width: 5rem;
  }

  .md\\:w-28{
    width: 7rem;
  }

  .md\\:w-3\\/5{
    width: 60%;
  }

  .md\\:w-5{
    width: 1.25rem;
  }

  .md\\:w-6{
    width: 1.5rem;
  }

  .md\\:w-9{
    width: 2.25rem;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:min-w-full{
    min-width: 100%;
  }

  .md\\:max-w-none{
    max-width: none;
  }

  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-col{
    flex-direction: column;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:gap-10{
    gap: 2.5rem;
  }

  .md\\:gap-3{
    gap: 0.75rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-5{
    gap: 1.25rem;
  }

  .md\\:gap-y-2{
    row-gap: 0.5rem;
  }

  .md\\:rounded-full{
    border-radius: 9999px;
  }

  .md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  .md\\:bg-auto{
    background-size: auto;
  }

  .md\\:bg-repeat{
    background-repeat: repeat;
  }

  .md\\:p-0{
    padding: 0px;
  }

  .md\\:p-1{
    padding: 0.25rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-\\[9px\\]{
    padding-top: 9px;
    padding-bottom: 9px;
  }

  .md\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .md\\:pl-2{
    padding-left: 0.5rem;
  }

  .md\\:pl-2\\.5{
    padding-left: 0.625rem;
  }

  .md\\:pr-0{
    padding-right: 0px;
  }

  .md\\:pt-0{
    padding-top: 0px;
  }

  .md\\:pt-14{
    padding-top: 3.5rem;
  }

  .md\\:pt-16{
    padding-top: 4rem;
  }

  .md\\:pt-20{
    padding-top: 5rem;
  }

  .md\\:pt-7{
    padding-top: 1.75rem;
  }

  .md\\:pt-\\[80\\%\\]{
    padding-top: 80%;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-2xl{
    font-size: 1.875rem;
    line-height: 2.375rem;
  }

  .md\\:text-\\[0px\\]{
    font-size: 0px;
  }

  .md\\:text-base{
    font-size: 1.125rem;
    line-height: 1.625rem;
  }

  .md\\:text-lg{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  .md\\:text-md{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .md\\:text-xs{
    font-size: 0.875rem;
    line-height: 1.125rem;
  }

  .md\\:shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:before\\:left-10::before{
    content: var(--tw-content);
    left: 2.5rem;
  }

  .md\\:before\\:top-20::before{
    content: var(--tw-content);
    top: 5rem;
  }

  .md\\:before\\:h-\\[calc\\(100\\%-50px\\)\\]::before{
    content: var(--tw-content);
    height: calc(100% - 50px);
  }

  .md\\:before\\:w-\\[3px\\]::before{
    content: var(--tw-content);
    width: 3px;
  }
}

@media (max-width: 767px){

  .sm\\:-left-14{
    left: -3.5rem;
  }

  .sm\\:-right-1{
    right: -0.25rem;
  }

  .sm\\:-right-4{
    right: -1rem;
  }

  .sm\\:-top-8{
    top: -2rem;
  }

  .sm\\:bottom-3{
    bottom: 0.75rem;
  }

  .sm\\:right-3{
    right: 0.75rem;
  }

  .sm\\:order-1{
    order: 1;
  }

  .sm\\:order-none{
    order: 0;
  }

  .sm\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .sm\\:-mt-2{
    margin-top: -0.5rem;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-8{
    margin-bottom: 2rem;
  }

  .sm\\:mr-0{
    margin-right: 0px;
  }

  .sm\\:mt-10{
    margin-top: 2.5rem;
  }

  .sm\\:mt-16{
    margin-top: 4rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:mt-8{
    margin-top: 2rem;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-56{
    height: 14rem;
  }

  .sm\\:h-60{
    height: 15rem;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-9{
    width: 2.25rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:min-w-full{
    min-width: 100%;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:gap-12{
    gap: 3rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-5{
    gap: 1.25rem;
  }

  .sm\\:gap-y-7{
    row-gap: 1.75rem;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:px-1\\.5{
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .sm\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .sm\\:pt-1{
    padding-top: 0.25rem;
  }

  .sm\\:pt-10{
    padding-top: 2.5rem;
  }

  .sm\\:pt-14{
    padding-top: 3.5rem;
  }

  .sm\\:pt-5{
    padding-top: 1.25rem;
  }

  .sm\\:pt-\\[50\\%\\]{
    padding-top: 50%;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:align-bottom{
    vertical-align: bottom;
  }

  .sm\\:text-2xl{
    font-size: 1.875rem;
    line-height: 2.375rem;
  }

  .sm\\:text-lg{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  .sm\\:text-md{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .sm\\:text-xl{
    font-size: 1.5rem;
    line-height: 1.875rem;
  }

  .sm\\:text-xs{
    font-size: 0.875rem;
    line-height: 1.125rem;
  }

  .sm\\:text-xxs{
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  .sm\\:ring-1{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  .sm\\:\\!invert{
    --tw-invert: invert(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  }

  .sm\\:before\\:left-8::before{
    content: var(--tw-content);
    left: 2rem;
  }

  .sm\\:before\\:top-14::before{
    content: var(--tw-content);
    top: 3.5rem;
  }

  .sm\\:before\\:h-\\[calc\\(100\\%-30px\\)\\]::before{
    content: var(--tw-content);
    height: calc(100% - 30px);
  }

  .sm\\:after\\:hidden::after{
    content: var(--tw-content);
    display: none;
  }

  .sm\\:after\\:\\!opacity-100::after{
    content: var(--tw-content);
    opacity: 1 !important;
  }

  .sm\\:after\\:hover\\:opacity-0:hover::after{
    content: var(--tw-content);
    opacity: 0;
  }

  .group:hover .sm\\:group-hover\\:invert-0{
    --tw-invert: invert(0);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }

  @media (max-width: 1199px){

    .sm\\:lg\\:\\!grid-cols-1{
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
  }
}

@media (max-width: 575px){

  .xs\\:relative{
    position: relative;
  }

  .xs\\:left-3{
    left: 0.75rem;
  }

  .xs\\:m-0{
    margin: 0px;
  }

  .xs\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .xs\\:mb-0{
    margin-bottom: 0px;
  }

  .xs\\:ml-auto{
    margin-left: auto;
  }

  .xs\\:grid{
    display: grid;
  }

  .xs\\:w-1\\/2{
    width: 50%;
  }

  .xs\\:w-10{
    width: 2.5rem;
  }

  .xs\\:w-2\\/3{
    width: 66.666667%;
  }

  .xs\\:w-\\[160\\%\\]{
    width: 160%;
  }

  .xs\\:w-full{
    width: 100%;
  }

  .xs\\:min-w-\\[105px\\]{
    min-width: 105px;
  }

  .xs\\:max-w-none{
    max-width: none;
  }

  .xs\\:basis-\\[29\\%\\]{
    flex-basis: 29%;
  }

  .xs\\:-translate-x-\\[92\\%\\]{
    --tw-translate-x: -92%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .xs\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xs\\:flex-col{
    flex-direction: column;
  }

  .xs\\:flex-wrap{
    flex-wrap: wrap;
  }

  .xs\\:items-start{
    align-items: flex-start;
  }

  .xs\\:gap-3{
    gap: 0.75rem;
  }

  .xs\\:gap-4{
    gap: 1rem;
  }

  .xs\\:gap-8{
    gap: 2rem;
  }

  .xs\\:gap-x-5{
    column-gap: 1.25rem;
  }

  .xs\\:gap-y-2{
    row-gap: 0.5rem;
  }

  .xs\\:border-r-0{
    border-right-width: 0px;
  }

  .xs\\:p-2{
    padding: 0.5rem;
  }

  .xs\\:p-2\\.5{
    padding: 0.625rem;
  }

  .xs\\:p-3{
    padding: 0.75rem;
  }

  .xs\\:p-5{
    padding: 1.25rem;
  }

  .xs\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xs\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xs\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .xs\\:pl-10{
    padding-left: 2.5rem;
  }

  .xs\\:pr-0{
    padding-right: 0px;
  }

  .xs\\:pr-24{
    padding-right: 6rem;
  }

  .xs\\:pt-10{
    padding-top: 2.5rem;
  }

  .xs\\:pt-12{
    padding-top: 3rem;
  }

  .xs\\:pt-16{
    padding-top: 4rem;
  }

  .xs\\:pt-\\[230\\%\\]{
    padding-top: 230%;
  }

  @media (max-width: 767px){

    .xs\\:sm\\:h-\\[8rem\\]{
      height: 8rem;
    }

    .xs\\:sm\\:w-full{
      width: 100%;
    }

    .xs\\:sm\\:grid-cols-1{
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .xs\\:sm\\:py-7{
      padding-top: 1.75rem;
      padding-bottom: 1.75rem;
    }

    .xs\\:sm\\:pt-0{
      padding-top: 0px;
    }

    .xs\\:sm\\:text-base{
      font-size: 1.125rem;
      line-height: 1.625rem;
    }

    .xs\\:sm\\:text-sm{
      font-size: 1rem;
      line-height: 1.375rem;
    }

    .xs\\:sm\\:text-xl{
      font-size: 1.5rem;
      line-height: 1.875rem;
    }
  }
}

.\\[\\&\\.active\\]\\:bg-primary\\/20.active{
  background-color: rgb(56 222 255 / 0.2);
}

.\\[\\&\\.active\\]\\:text-black.active{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAKA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,mOAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAKhB,iBAAsD;EAAtD,kBAAsD;EAAtD;AALgB;AAKhB;;EAAA;IAAA,kBAAsD;IAAtD;EAAsD;AAAA;AAAtD;;EAAA;IAAA,kBAAsD;IAAtD;EAAsD;AAAA;AAAtD;;EAAA;IAAA,qBAAsD;IAAtD;EAAsD;AAAA;AAExD,mBAAmB;AAEjB;EAAA,iBAAiD;EAAjD;AAAiD;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAGjD;EAAA,iBAAiD;EAAjD;AAAiD;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAAjD;;EAAA;IAAA,iBAAiD;IAAjD;EAAiD;AAAA;AAGnD,eAAe;AAEb;EAAA,kBAAwU;EAAxU,oBAAwU;EAAxU,mBAAwU;EAAxU,uBAAwU;EAAxU,gBAAwU;EAAxU,sBAAwU;EAAxU,iBAAwU;EAAxU,oBAAwU;EAAxU,qBAAwU;EAAxU,sBAAwU;EAAxU,eAAwU;EAAxU,qBAAwU;EAAxU,gBAAwU;EAAxU,sBAAwU;EAAxU,oBAAwU;EAAxU,gDAAwU;EAAxU;AAAwU;AAAxU;EAAA,kBAAwU;EAAxU,QAAwU;EAAxU,SAAwU;EAAxU,YAAwU;EAAxU,YAAwU;EAAxU,WAAwU;EAAxU,0MAAwU;EAAxU,0BAAwU;EAAxU;AAAwU;AAAxU;EAAA,0BAAwU;EAAxU;AAAwU;AAAxU;;EAAA;IAAA,oBAAwU;IAAxU,uBAAwU;IAAxU,oBAAwU;IAAxU;EAAwU;AAAA;AAAxU;;EAAA;IAAA,kBAAwU;IAAxU,mBAAwU;IAAxU,mBAAwU;IAAxU;EAAwU;AAAA;AAGxU;EAAA,oBAAkO;EAAlO,mBAAkO;EAAlO,uBAAkO;EAAlO,sBAAkO;EAAlO,iBAAkO;EAAlO,sBAAkO;EAAlO,mDAAkO;EAAlO,kBAAkO;EAAlO,mDAAkO;EAAlO,qBAAkO;EAAlO,wBAAkO;EAAlO,kBAAkO;EAAlO,mBAAkO;EAAlO,eAAkO;EAAlO,qBAAkO;EAAlO,gBAAkO;EAAlO,sBAAkO;EAAlO,oBAAkO;EAAlO,gDAAkO;EAAlO;AAAkO;AAAlO;EAAA,kBAAkO;EAAlO,yDAAkO;EAAlO,oBAAkO;EAAlO;AAAkO;AAAlO;;EAAA;IAAA,qBAAkO;IAAlO,wBAAkO;IAAlO,oBAAkO;IAAlO;EAAkO;AAAA;AAAlO;;EAAA;IAAA,kBAAkO;IAAlO,mBAAkO;IAAlO,mBAAkO;IAAlO;EAAkO;AAAA;AAGlO;EAAA,oBAAkO;EAAlO,mBAAkO;EAAlO,uBAAkO;EAAlO,sBAAkO;EAAlO,iBAAkO;EAAlO,sBAAkO;EAAlO,mDAAkO;EAAlO,kBAAkO;EAAlO,yDAAkO;EAAlO,qBAAkO;EAAlO,wBAAkO;EAAlO,kBAAkO;EAAlO,mBAAkO;EAAlO,eAAkO;EAAlO,qBAAkO;EAAlO,gBAAkO;EAAlO,sBAAkO;EAAlO,oBAAkO;EAAlO,0CAAkO;EAAlO;AAAkO;AAAlO;EAAA,kBAAkO;EAAlO,mDAAkO;EAAlO,oBAAkO;EAAlO;AAAkO;AAAlO;;EAAA;IAAA,qBAAkO;IAAlO,wBAAkO;IAAlO,oBAAkO;IAAlO;EAAkO;AAAA;AAAlO;;EAAA;IAAA,kBAAkO;IAAlO,mBAAkO;IAAlO,mBAAkO;IAAlO;EAAkO;AAAA;AAGlO;EAAA,qBAAgE;EAAhE,wBAAgE;EAAhE,oBAAgE;EAAhE,qBAAgE;EAAhE,mBAAgE;EAAhE;AAAgE;AAAhE;;EAAA;IAAA,qBAAgE;IAAhE;EAAgE;AAAA;AAAhE;;EAAA;IAAA,qBAAgE;IAAhE,qBAAgE;IAAhE,sBAAgE;IAAhE,oBAAgE;IAAhE;EAAgE;AAAA;AAGhE;EAAA;AAAU;AAEZ,mBAAmB;AAEnB,qBAAqB;AAEnB;EAAA,0IAAsJ;EAAtJ,6BAAsJ;UAAtJ,qBAAsJ;EAAtJ,8BAAsJ;EAAtJ,mBAAsJ;EAAtJ,cAAsJ;EAAtJ,gBAAsJ;EAAtJ;AAAsJ;AAAtJ;;EAAA;IAAA,eAAsJ;IAAtJ;EAAsJ;AAAA;AAAtJ;;EAAA;IAAA,eAAsJ;IAAtJ,mBAAsJ;IAAtJ;EAAsJ;AAAA;AAAtJ;;EAAA;IAAA,mBAAsJ;IAAtJ;EAAsJ;AAAA;AAAtJ;;EAAA;IAAA,iBAAsJ;IAAtJ;EAAsJ;AAAA;AAGtJ;EAAA,qBAAuI;EAAvI,0IAAuI;EAAvI,6BAAuI;UAAvI,qBAAuI;EAAvI,8BAAuI;EAAvI,eAAuI;EAAvI,qBAAuI;EAAvI,gBAAuI;EAAvI;AAAuI;AAAvI;;EAAA;IAAA,eAAuI;IAAvI;EAAuI;AAAA;AAAvI;;EAAA;IAAA,mBAAuI;IAAvI;EAAuI;AAAA;AAAvI;;EAAA;IAAA,iBAAuI;IAAvI;EAAuI;AAAA;AAKzI,yBAAyB;AAGvB;EAAA,kBAAsH;EAAtH,gBAAsH;EAAtH,sBAAsH;EAAtH,kBAAsH;EAAtH,yDAAsH;EAAtH,2CAAsH;EAAtH,yDAAsH;EAAtH;AAAsH;AAAtH;EAAA,8BAAsH;EAAtH;AAAsH;AAGxH,aAAa;AAEX;EAAA,WAA+E;EAA/E,yBAA+E;EAA/E,mBAA+E;EAA/E,mBAA+E;EAA/E,qBAA+E;EAA/E,oBAA+E;EAA/E;AAA+E;AAA/E;;EAAA;IAAA,eAA+E;IAA/E;EAA+E;AAAA;AAG/E;EAAA,wBAAyE;EAAzE,sBAAyE;EAAzE,gEAAyE;EAAzE,oBAAyE;EAAzE,qBAAyE;EAAzE,uBAAyE;EAAzE;AAAyE;AAAzE;EAAA;AAAyE;AAAzE;EAAA;AAAyE;AAGzE;EAAA,0IAA0F;EAA1F,6BAA0F;UAA1F,qBAA0F;EAA1F,mBAA0F;EAA1F,oBAA0F;EAA1F,gBAA0F;EAA1F;AAA0F;AAA1F;;EAAA;IAAA,kBAA0F;IAA1F;EAA0F;AAAA;AAA1F;;EAAA;IAAA,mBAA0F;IAA1F;EAA0F;AAAA;AAG1F;EAAA,qBAAuC;EAAvC,wBAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;AAAvC;EAAA;AAAuC;AAAvC;EAAA;AAAuC;AA3D3C;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AA+DnB;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;;AAEjB;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,oEAAgE;EAChE,cAAkP;EAAlP,qBAAkP;EAAlP,YAAkP;EAAlP,WAAkP;EAAlP,qBAAkP;EAAlP,iBAAkP;EAAlP,mBAAkP;EAAlP,sBAAkP;EAAlP,mDAAkP;EAAlP,6BAAkP;EAAlP,8DAAkP;EAAlP,sCAAkP;EAAlP,uCAAkP;EAAlP,gBAAkP;EAAlP,0BAAkP;AACpP;AADE;;EAAA,0BAAkP;EAAlP;AAAkP;AAAlP;;EAAA,6BAAkP;EAAlP;AAAkP;AAAlP;;EAAA;;IAAA;EAAkP;AAAA;AAAlP;;EAAA;;IAAA;EAAkP;AAAA;AAAlP;;EAAA;;IAAA,cAAkP;IAAlP;EAAkP;AAAA;AAAlP;;EAAA;;IAAA,YAAkP;IAAlP,wBAAkP;IAAlP;EAAkP;AAAA;AAEpP;;EAEE,oEAAsE;EACtE,2BAA6B;EAA7B,4BAA6B;AAC/B;AAEE;EAAA,WAA4F;EAA5F,aAA4F;EAA5F,oBAA4F;EAA5F,sBAA4F;EAA5F,mBAA4F;EAA5F;AAA4F;AAA5F;;EAAA;IAAA;EAA4F;AAAA;AAA5F;;EAAA;IAAA;EAA4F;AAAA;AAA5F;;EAAA;IAAA;EAA4F;AAAA;;AAG9F,wBAAwB;AAEtB;EAAA,8OAA0B;EAA1B,0BAA0B;EAA1B;AAA0B;AAG1B;EAAA;AAAa;AAGb;EAAA,uBAAsB;EAAtB;AAAsB;AAGtB;EAAA,eAA4F;EAA5F,SAA4F;EAA5F,QAA4F;EAA5F,WAA4F;EAA5F,aAA4F;EAA5F,YAA4F;EAA5F,WAA4F;EAA5F,mBAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAG5F;EAAA,6BAAgC;EAAhC;AAAgC;AAGhC;EAAA,WAAqF;EAArF,sBAAqF;EAArF,aAAqF;EAArF,sBAAqF;EAArF,uBAAqF;EAArF,YAAqF;EAArF,qBAAqF;EAArF,sBAAqF;EAArF,yDAAqF;EAArF,oBAAqF;EAArF;AAAqF;AAKrF;;;EAAA,uBAA2B;EAA3B,sBAA2B;EAA3B;AAA2B;AAG3B;EAAA;AAAc;AAEhB,oBAAoB;;AAEpB;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB;;;;;GAKC;EACD,oEAAoE;AACtE;;AAEA;;;;GAIG;;AAEH;EACE;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EAExB,sCAAsC;AACxC;AACA,cAAc;AASd;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;;EAEE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AA/WA;;EAAA;EAAA;MAAA,qBAgXA;MAhXA,wBAgXA;MAhXA,oBAgXA;MAhXA,qBAgXA;MAhXA,mBAgXA;MAhXA;IAgXA;EAhXA;;MAAA;QAAA,qBAgXA;QAhXA;MAgXA;IAAA;EAhXA;;MAAA;QAAA,qBAgXA;QAhXA,qBAgXA;QAhXA,sBAgXA;QAhXA,oBAgXA;QAhXA;MAgXA;IAAA;EAhXA;MAAA;IAgXA;EAAA;AAAA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,yBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,2BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,eAgXA;EAhXA,eAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,+EAgXA;EAhXA,mGAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,iCAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,iCAgXA;EAhXA,yCAgXA;EAhXA;AAgXA;;AAhXA;EAAA,yCAgXA;EAhXA;AAgXA;;AAhXA;EAAA,8BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,2GAgXA;EAhXA,yGAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,8BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,wBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,mBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,6BAgXA;UAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,yBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,0BAgXA;EAhXA,sBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,kBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,qBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,mBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,eAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA,8BAgXA;EAhXA;AAgXA;;AAhXA;EAAA,yBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,yBAgXA;EAhXA;AAgXA;;AAhXA;EAAA,sBAgXA;EAhXA;AAgXA;;AAhXA;;EAAA;IAAA;EAgXA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,uBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,sBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,+BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,gCAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;;IAAA;MAAA;IAgXA;EAAA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,gBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,gBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,6EAgXA;IAhXA,iGAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,sBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,kBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,eAgXA;IAhXA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,mBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,2GAgXA;IAhXA,yGAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oCAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,0BAgXA;IAhXA;EAgXA;;EAhXA;IAAA,sBAgXA;IAhXA;EAgXA;;EAhXA;;IAAA;MAAA;IAgXA;EAAA;AAAA;;AAhXA;;EAAA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,iBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,sBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA,qBAgXA;IAhXA;EAgXA;;EAhXA;IAAA,oBAgXA;IAhXA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;IAAA;EAgXA;;EAhXA;;IAAA;MAAA;IAgXA;;IAhXA;MAAA;IAgXA;;IAhXA;MAAA;IAgXA;;IAhXA;MAAA,oBAgXA;MAhXA;IAgXA;;IAhXA;MAAA;IAgXA;;IAhXA;MAAA,mBAgXA;MAhXA;IAgXA;;IAhXA;MAAA,eAgXA;MAhXA;IAgXA;;IAhXA;MAAA,iBAgXA;MAhXA;IAgXA;EAAA;AAAA;;AAhXA;EAAA;AAgXA;;AAhXA;EAAA,oBAgXA;EAhXA;AAgXA","sourcesContent":["@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  .container {\n    @apply max-w-[1920px] px-20 3xl:px-16 md:px-12 sm:px-9;\n  }\n  /* COMMON SPACING */\n  .section-space {\n    @apply py-32 2xl:py-24 xl:py-20 md:py-16 sm:py-12;\n  }\n  .section-space-small {\n    @apply py-24 2xl:py-20 xl:py-20 md:py-16 sm:py-12;\n  }\n\n  /* BUTTON CSS */\n  .btn-primary {\n    @apply font-bold text-sm text-white tracking-wider py-4 px-7 rounded-xl inline-flex items-center justify-center duration-300 relative overflow-hidden after:absolute after:w-[200%] after:duration-300 after:h-full after:bg-btn_gradient after:top-0 after:left-0 after:-z-10 hover:after:-left-full lg:py-3 lg:px-6 sm:px-4 sm:text-xs;\n  }\n  .btn-secondary {\n    @apply py-3.5 px-8 text-sm font-bold tracking-wider text-white bg-black duration-300 border-2 border-black rounded-xl inline-flex items-center justify-center hover:bg-white hover:text-black lg:py-2.5 lg:px-6 sm:px-4 sm:text-xs;\n  }\n  .btn-border {\n    @apply py-3.5 px-8 text-sm font-bold tracking-wider text-black bg-white duration-300 border-2 border-black rounded-xl inline-flex items-center justify-center hover:bg-black hover:text-white lg:py-2.5 lg:px-6 sm:px-4 sm:text-xs;\n  }\n  .btn-sm {\n    @apply py-1.5 px-6 text-xs lg:px-5 sm:px-3 sm:py-1 sm:rounded-lg;\n  }\n  .btn-sm img {\n    @apply w-5;\n  }\n  /* BUTTON CSS END */\n\n  /* MAIN HEADING CSS */\n  .main-heading-h1 {\n    @apply text-6xl 3xl:text-5xl xl:text-4xl lg:text-3xl sm:text-2.5xl xl:leading-none font-monserrat font-black bg-clip-text text-transparent bg-gradient;\n  }\n  .main-heading-h2 {\n    @apply text-5xl 2xl:text-4xl lg:text-3xl sm:text-2.5xl font-monserrat font-black bg-clip-text text-transparent bg-gradient inline-block;\n  }\n  .main-heading-h4 {\n    @apply text-xl 2xl:text-xl lg:text-xl sm:text-lg font-monserrat font-black bg-clip-text text-transparent bg-gradient inline-block;\n  }\n  /* MAIN HEADING CSS END */\n\n  .dropdown {\n    @apply absolute bg-white rounded-xl overflow-hidden focus-visible:outline-none shadow-[0_25px_50px_0_rgba(0,0,0,0.08)];\n  }\n\n  /* TABLE TH */\n  .table-main {\n    @apply border-collapse w-full text-base text-black md:text-sm whitespace-nowrap;\n  }\n  .table-th {\n    @apply px-2 first:pl-0 last:pr-0 text-left border-b border-b-dark-40 pb-3;\n  }\n  .table-th span {\n    @apply text-lg bg-gradient text-transparent bg-clip-text font-bold md:text-md sm:text-base;\n  }\n  .table-td {\n    @apply py-2.5 px-2 first:pl-0 last:pr-0;\n  }\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* SLIDER ARROW */\n\n.slick-track {\n  margin-left: 0;\n  display: flex;\n}\n.slick-slide {\n  min-height: 100%;\n  height: auto;\n}\n.slick-slide > div {\n  height: 100%;\n}\n.slick-prev,\n.slick-next {\n  background-image: url(./assets/images/next-arrow.svg) !important;\n  @apply duration-300 !bg-black !bg-no-repeat !bg-center p-7 border border-solid border-black rounded-full w-auto h-auto -right-14 -mr-2 before:hidden hover:!bg-white 3xl:mr-0 lg:p-6 md:p-5 md:-right-10 sm:p-4 sm:-right-8 sm:bg-[length:60%_60%];\n}\n.slick-prev:hover,\n.slick-next:hover {\n  background-image: url(./assets/images/next-arrow-hover.svg) !important;\n  @apply bg-no-repeat bg-center;\n}\n.slick-prev {\n  @apply right-auto rotate-180 -translate-y-2/4 -left-14 -ml-2 3xl:ml-0 md:-left-10 sm:-left-8;\n}\n\n/* DATEPICKER CSS start*/\n.react-datepicker {\n  @apply !font-sans !text-sm;\n}\n.react-datepicker-wrapper {\n  @apply w-full;\n}\n.react-datepicker__portal {\n  @apply !w-full !h-full;\n}\n.react-datepicker__tab-loop {\n  @apply w-full h-full fixed left-0 top-0 z-30 flex items-center justify-center bg-darkGray/80;\n}\n.react-datepicker-popper {\n  @apply !relative !transform-none;\n}\n.react-datepicker__children-container {\n  @apply !w-full clear-both !m-0 justify-center flex py-3 gap-3 border-t border-dark-40;\n}\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  @apply !w-8 !h-8 !leading-8;\n}\n.react-datepicker__triangle {\n  @apply !hidden;\n}\n/* LOADER CSS start*/\n\n.configure-border-1 {\n  width: 112px;\n  height: 112px;\n  padding: 3px;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: solid 3px #0d0b0e;\n  animation: configure-clockwise 3s ease-in-out 0s infinite alternate;\n}\n\n.configure-border-2 {\n  width: 115px;\n  height: 115px;\n  padding: 3px;\n  left: -115px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgb(63, 249, 220);\n  transform: rotate(45deg);\n  background-image: radial-gradient(\n    135% 135% at 99.89% 100.17%,\n    #ffcf14 0%,\n    #ee8fff 52%,\n    #38deff 100%\n  );\n  animation: configure-xclockwise 3s ease-in-out 0s infinite alternate;\n}\n\n/* .configure-core {\n    width: 100%;\n    height: 100%;\n    background-color: #1d2630;\n} */\n\n@keyframes configure-clockwise {\n  0% {\n    transform: rotate(0);\n  }\n  25% {\n    transform: rotate(90deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  75% {\n    transform: rotate(270deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes configure-xclockwise {\n  0% {\n    transform: rotate(45deg);\n  }\n  25% {\n    transform: rotate(-45deg);\n  }\n  50% {\n    transform: rotate(-135deg);\n  }\n  75% {\n    transform: rotate(-225deg);\n  }\n  100% {\n    transform: rotate(-315deg);\n  }\n}\n.loader-btn {\n  width: 28px;\n  height: 28px;\n  border: 5px dotted #38deff;\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n  margin: -5px 10px -5px 0;\n  -webkit-animation: rotation 2s linear infinite;\n  animation: rotation 2s linear infinite;\n}\n/* keyFrames */\n@-webkit-keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* VideoPlayer.css */\n.custom-video::-webkit-media-controls-fullscreen-button,\n.custom-video::-webkit-media-controls-overflow-button {\n  display: none !important;\n}\n\n/* to hide react-quill input box */\n.bubble > .ql-container > .ql-clipboard {\n  display: none !important;\n}\n\n.bubble > .ql-container > .ql-tooltip {\n  display: none !important;\n}\n.bubble > .ql-container > .ql-tooltip > .ql-tooltip-editor > input a {\n  display: none !important;\n}\n\n/* react-quill */\n\n.font-change-css h1 {\n  font-size: 2.25rem;\n  font-weight: 700;\n  padding: 8px 0px;\n}\n\n.font-change-css h2 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  padding: 8px 0px;\n}\n\n.font-change-css h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  padding: 8px 0px;\n}\n\n.font-change-css h4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  padding: 8px 0px;\n}\n\n.font-change-css h5 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  padding: 8px 0px;\n}\n\n.font-change-css h6 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 8px 0px;\n}\n\n.font-change-css p {\n  padding-top: 0.6rem;\n  padding-bottom: 0.6rem;\n}\n\n.font-change-css ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n}\n.font-change-css ul > li {\n  padding-top: 0.6rem;\n  padding-bottom: 0.6rem;\n}\n.font-change-css ol {\n  list-style-type: decimal;\n  padding-left: 1.5rem;\n}\n.font-change-css ol > li {\n  padding-top: 0.6rem;\n  padding-bottom: 0.6rem;\n}\n\n.font-change-css p img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media (min-width: 0) and (max-width: 767px) {\n  .font-change-css h1 {\n    font-size: 1.5rem;\n    font-weight: 700;\n  }\n\n  .font-change-css h2 {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .font-change-css h3 {\n    font-size: 1rem;\n    font-weight: 700;\n  }\n\n  .font-change-css h4 {\n    font-size: 0.925rem;\n    font-weight: 600;\n  }\n\n  .font-change-css h5 {\n    font-size: 0.8rem;\n    font-weight: 600;\n  }\n\n  .font-change-css h6 {\n    font-size: 0.8rem;\n    font-weight: 600;\n  }\n  .font-change-css ul {\n    list-style-type: disc;\n    padding-left: 1.5rem;\n  }\n  .font-change-css ul > li {\n    padding-bottom: 0.5rem;\n    padding-top: 0.5rem;\n  }\n  .font-change-css ol {\n    list-style-type: decimal;\n    padding-left: 1.5rem;\n  }\n  .font-change-css ol > li {\n    padding-bottom: 0.5rem;\n    padding-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
